import { Pencil, Trash2, Pin, Copy, MessageSquareReply, MessageSquare, SmilePlus } from '@tamagui/lucide-icons'
import { useAppStore } from '@/store'
import { ContextMenu } from '../../common'
import type { ContextMenuSection } from '../../common'
import { messages } from '@/mocks'

export function MessageContextMenu() {
  const {
    contextMenu,
    closeContextMenu,
    setEditingMessageId,
    setDeleteMessageId,
    setReplyingToMessageId,
    openThread,
  } = useAppStore()

  if (contextMenu.type !== 'message' || !contextMenu.targetId) return null

  const messageId = contextMenu.targetId

  // Find message content for copy
  let messageContent = ''
  for (const channelMessages of Object.values(messages)) {
    const found = channelMessages.find((m) => m.id === messageId)
    if (found) {
      messageContent = found.content
      break
    }
  }

  const sections: ContextMenuSection[] = [
    {
      items: [
        {
          id: 'reply',
          label: 'Reply',
          icon: <MessageSquareReply size={14} color="$sidebarMuted" />,
          action: () => setReplyingToMessageId(messageId),
        },
        {
          id: 'edit',
          label: 'Edit Message',
          icon: <Pencil size={14} color="$sidebarMuted" />,
          action: () => setEditingMessageId(messageId),
        },
        {
          id: 'pin',
          label: 'Pin Message',
          icon: <Pin size={14} color="$sidebarMuted" />,
          action: () => {
            // Mock: toggle pin in local data
          },
        },
      ],
    },
    {
      items: [
        {
          id: 'thread',
          label: 'Create Thread',
          icon: <MessageSquare size={14} color="$sidebarMuted" />,
          action: () => openThread(messageId),
        },
        {
          id: 'react',
          label: 'Add Reaction',
          icon: <SmilePlus size={14} color="$sidebarMuted" />,
          action: () => {
            // Mock: would open emoji picker
          },
        },
        {
          id: 'copy',
          label: 'Copy Text',
          icon: <Copy size={14} color="$sidebarMuted" />,
          action: () => {
            navigator.clipboard.writeText(messageContent)
          },
        },
      ],
    },
    {
      items: [
        {
          id: 'delete',
          label: 'Delete Message',
          icon: <Trash2 size={14} color="$error" />,
          danger: true,
          action: () => setDeleteMessageId(messageId),
        },
      ],
    },
  ]

  return (
    <ContextMenu
      x={contextMenu.x}
      y={contextMenu.y}
      sections={sections}
      onClose={closeContextMenu}
    />
  )
}
